export const MESSAGE_MAX_TAKE = 100;
export const BOTTOM_SCROLL_THRESHOLD = 3000;
